module.exports = require('../build/DayPickerInput');



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/react-day-picker/DayPickerInput/index.js
// module id = 614
// module chunks = 0